
export enum MasterType {
    LOCATION = 1,
    CALENDAR = 2,
    PRODUCT = 3,
    DC = 4,
    PROMO = 5,
    VENDOR = 6,
    PRICE = 7
 }

export enum MasterReportId {
    ALL = 60,
    LOCATION = 61,
    PRODUCT = 62,
    DC = 63,
    PRICE = 64,
    VENDOR = 65,
    PROMO = 66
}